import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { NavigationBreadcrumbs as BaseNavigationBreadcrumbs } from "@sprout/client-components/dist/Navigation";
import { Flex } from "sprout-ui-primitives";
import { themeGet } from "sprout-ui-theme";
import styled from "styled-components";
const NavigationBreadcrumbs = styled(BaseNavigationBreadcrumbs)`
  li a {
    font-weight: ${themeGet("fontWeights.bold")};
  }
`;
const TopicPageNavigationBreadcrumbs = (props)=>{
    const { topic  } = props;
    const { owner  } = topic.rootTopicOrSelf || {};
    const breadcrumbsList = useMemo(()=>{
        return [
            ...topic.breadcrumbsList || []
        ].reverse();
    }, [
        topic
    ]);
    if (!owner || breadcrumbsList.length === 0) return null;
    return /*#__PURE__*/ _jsx(Flex, {
        justifyContent: "center",
        height: "48px",
        alignItems: "center",
        children: /*#__PURE__*/ _jsx(NavigationBreadcrumbs, {
            owner: owner,
            breadcrumbsList: breadcrumbsList
        })
    });
};
export default TopicPageNavigationBreadcrumbs;
